export default __webpack_public_path__ + "static/media/sticker-h.ef80f85a.png";